import { render, staticRenderFns } from "./Alerta.vue?vue&type=template&id=347b9f00"
import script from "./Alerta.vue?vue&type=script&lang=js"
export * from "./Alerta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports